<div *ngIf="suspended"
     role="status"
     class="sticky top-0 left-0 right-0 z-[9998] border-b shadow-sm"
     [ngClass]="isDarkMode
       ? 'bg-amber-950 text-amber-50 border-amber-800'
       : 'bg-amber-50 text-amber-950 border-amber-200'">
  <div class="mx-auto max-w-full px-4 sm:px-6 md:px-8 lg:px-14">
    <div class="flex items-start gap-3 py-2.5 sm:items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="mt-0.5 h-5 w-5 flex-shrink-0 sm:mt-0" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true"
           [ngClass]="isDarkMode ? 'text-amber-300' : 'text-amber-600'">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
      </svg>
      <p class="text-sm font-medium leading-snug">
        Your account has been temporarily suspended, to re-activate it please write an email to your account manager.
        <a href="mailto:tabata&#64;meetzy.io"
           class="font-semibold underline underline-offset-2"
           [ngClass]="isDarkMode ? 'text-amber-200 hover:text-white' : 'text-amber-800 hover:text-amber-950'">tabata&#64;meetzy.io</a>
      </p>
    </div>
  </div>
</div>
